import React from "react";

const StockDetailsById = () => {
  return <div>StockDetailsById</div>;
};

export default StockDetailsById;
